import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './assets/main.css'
import './styles/move-public-shell.css'
import './styles/move-app-theme.css'
import { getInitialMoveTheme } from './composables/useMoveTheme'
import MoveSelect from './components/MoveSelect.vue'

document.documentElement.classList.add(getInitialMoveTheme() === 'dark' ? 'move-theme-dark' : 'move-theme-light')

const app = createApp(App)
app.component('MoveSelect', MoveSelect)

store.dispatch('auth/fetchSession').finally(() => {
  app.use(store)
  app.use(router)
  app.mount('#app')
})
